import {
  CalculateTokenUsageRequest,
  H2OGPTeService_CalculateTokenUsage,
} from '@src/gen/ai/h2o/cloud/telemetry_read_api/h2ogpte/v1/h2ogpte_pb';
import {
  CalculateMaxUsageRequest,
  CalculateResourceUsageRequest,
  CalculateUsageRequest,
  ComponentService_ListComponents,
  GetQuotaRequest,
  ListComponentsRequest,
  QuotaService_GetQuota,
  UsageService_CalculateMaxUsage,
  UsageService_CalculateResourceUsage,
  UsageService_CalculateUsage,
} from '@src/gen/ai/h2o/cloud/telemetry_read_api/v1/aiunits_pb';
import { fetchWrapRPC, getAccessToken } from '@shared/services/appstore/api';

async function fetchAllPages<
  Req extends { pageToken?: string },
  Res extends { usage?: unknown[]; groupedBy?: unknown; nextPageToken?: string }
>(fetchFn: (req: Req) => Promise<Res>, req: Req): Promise<Res> {
  const firstPage = await fetchFn(req);
  if (!firstPage.nextPageToken) {
    return firstPage;
  }

  const allUsage = [...(firstPage.usage || [])];
  let pageToken: string | undefined = firstPage.nextPageToken;

  while (pageToken) {
    const nextPage = await fetchFn({ ...req, pageToken });
    if (nextPage.usage) {
      allUsage.push(...nextPage.usage);
    }
    pageToken = nextPage.nextPageToken;
  }

  return { ...firstPage, usage: allUsage, nextPageToken: undefined };
}

export class TelemetryServiceImpl {
  private basePath: string;
  constructor(basePath?: string) {
    this.basePath = basePath || '';
  }

  public setBasePath = (path: string) => {
    this.basePath = path;
  };

  public async calculateMaxUsage(req: CalculateMaxUsageRequest) {
    return await fetchWrapRPC(UsageService_CalculateMaxUsage, { basePath: this.basePath })({ ...req });
  }

  public async calculateUsage(req: CalculateUsageRequest) {
    return await fetchWrapRPC(UsageService_CalculateUsage, { basePath: this.basePath })({ ...req });
  }

  public async calculateResourceUsage(req: CalculateResourceUsageRequest) {
    const options = { basePath: this.basePath, bearerToken: getAccessToken };
    return fetchAllPages(fetchWrapRPC(UsageService_CalculateResourceUsage, options), req);
  }

  public async getQuota(req: GetQuotaRequest = {}) {
    return await fetchWrapRPC(QuotaService_GetQuota, { basePath: this.basePath })({ ...req });
  }

  public async listComponents(req: ListComponentsRequest = {}) {
    const options = { basePath: this.basePath, bearerToken: getAccessToken };
    return await fetchWrapRPC(ComponentService_ListComponents, options)({ ...req });
  }

  public async calculateTokenUsage(req: CalculateTokenUsageRequest) {
    const options = { basePath: this.basePath, bearerToken: getAccessToken };
    return fetchAllPages(fetchWrapRPC(H2OGPTeService_CalculateTokenUsage, options), req);
  }
}
